import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/invoices`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (params) {
    // const options = {
    //     headers: {
    //         'Accept': 'application/vnd.api+json',
    //         'Content-Type': 'application/vnd.api+json',
    //     },
    // };
    const options = {
        params: {
            include: params.include
        },
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.get(`${url}/invoices/${params.id}`, options)
        .then(response => {
            let invoice = jsona.deserialize(response.data);
            delete invoice.links;
            return invoice;
        });
}

function add (invoice) {
    const payload = jsona.serialize({
        stuff: invoice,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/invoices`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (invoice) {
    const payload = jsona.serialize({
        stuff: invoice,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/invoices/${invoice.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/invoices/${id}`, options);
}
function execute (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/invoice/execute/${id}`, options)
        .then(response => {
            let invoice = jsona.deserialize(response.data);
            // delete invoice.links;
            // console.log(invoice)
            return invoice;
        });
}
function update1 (invoice) {
    const payload = jsona.serialize({
        stuff: invoice,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/invoice/status/${invoice.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}
function downloadPdf(id, preview = false) {
    const options = {
        headers: {
            Accept: 'application/pdf'
        },
        responseType: 'blob',
        params: {
            preview: preview ? 1 : 0
        }
    };

    return axios.get(
        `${url}/invoices/${id}/pdf`,
        options
    );
}

function downloadPdfStatus(id) {
    console.log('downloadPdfStatus id:', id);
    const options = {
        headers: {
            Accept: 'application/json'
        }
    };

    return axios
        .get(`${url}/invoices/${id}/pdf/status`, options)
        .then(response => response.data);
}

function generatePdf(id) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios
        .post(`${url}/invoices/${id}/pdf`, {}, options)
        .then(response => response.data);
}


export default {
    list,
    get,
    add,
    update,
    destroy,
    execute,
    update1,
    downloadPdf,
    downloadPdfStatus,
    generatePdf
};

